import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectGatewaysQueryItems } from '../../../../../redux/gateways/selector';
import { gateways } from '../../../../../redux/gateways/action';
import GatewayComponent from '../component/gateway.component';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import { dbas } from '../../../../../redux/dbas/action';


const Gateway= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGatewaysQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
      const dbasItems = useSelector(selectDbasListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedGateway,
    setSelectedGateway
  ] = useState<any>([])
 
  const fetchgatewayById= ()=>{
    dispatch(gateways.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/query`,entity:'gateways',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGateway({ ...selectedGateway, [field]: event });
  }

  useEffect(
    () => {
        dispatch(dbas.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas/list`,entity:'domains',jsonData:{
                }}))
      if (parmas?.id > 0) {
        fetchgatewayById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedGateway(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(gateways.resetAction({ actionType: 'update' }))
     await dispatch(gateways.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways`,entity:'gateways',jsonData:{
          
    Records: [
      {
        
       
         ...selectedGateway
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(gateways.resetAction({ actionType: 'create' }))
      await dispatch(gateways.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways`,entity:'gateways',jsonData:{
          
      Records: [
        {
        
         
            ...selectedGateway
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/gateways')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <GatewayComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedGateway={selectedGateway}
           back={back}
           handleFormSubmit={handleFormSubmit}
           dbas={dbasItems?.result?.items}
           id={parmas?.id}
          /> 
    } 
          </>
    )
    
    }
   
    export default Gateway;
